module.exports = __webpack_public_path__ + "static/img/2.2fd3f87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/virtual-lesson-plan/article/2.jpg
// module id = ogV5
// module chunks = 1